<template>
  <summary-table
    data-field="pay"
    format-type="number"
  />
</template>

<script>
import SummaryTable from '@core/components/summary/SummaryTable.vue'

export default {
  name: 'TotalPay',
  components: {
    SummaryTable,
  },
}
</script>
